/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc controller
 * @name ServiceEngineController
 */
angular.module('aviApp').controller('ServiceEngineController', [
'$scope', 'resolveSE', 'myAccount', 'Auth',
function($scope, se, myAccount, Auth) {
    $scope.myAccount = myAccount;
    $scope.se = se;
    $scope.Auth = Auth;

    /** @deprecated */
    $scope.ServiceEngine = se;

    $scope.$on('$destroy', () => {
        se.destroy();
    });
}]);
